<main id="main">
    <div class="mobile-header-stickybackButton"><a onclick="history.back()"
        class="mobile-header"><i class="bx bx-chevron-left"
            style=" font-size: 1.6em;"></i> Back </a></div>
    <!-- ======= About Us Section ======= -->
    <div class="leader-baord-section">
        <div class="container">
            <div class="row">
                <div class="col-md-12 m-p-p-0">
                    <div class="col-md-12 p-p-0">
                       
                        <div class="l-wrapper" id="wrapper" style="max-width: 100%;margin-bottom: 1.5rem;">
                            <div class="header-heading-div">
                                <div class="profile-div">
                                    <!-- ======= User Image start ======= -->
                                    <div class="image">
                                        
                                        <img [src]="profilepic" [alt]="fullName">
                                    </div>
                                    
                                    <div class="details">
                                        <h4 class="playername ">{{fullName}}</h4>
                                        <span class="user-id-div">
                                            <a href="#" class="flag">
                                                <img src="assets/img/players/flag2.png" alt="">
                                            </a> {{cityname}}, {{statename}} </span>
                                        <div class="date"> Age: {{age}} | Gender: {{gender}}  </div>
                                    </div>
                                    <!-- ======= User Details end ======= -->
                                </div>
                                <!-- ======= User ranking start ======= -->
                                <div class="right-filter">
                                    <!-- <div class="total-ranking "> Final Ranking Points: <strong>{{userLatestScore}}</strong> -->
                                        <div class="total-ranking "> Final Points: <strong>{{userLatestScore}}</strong>
                                    </div>

                                </div>
                                <!-- ======= User ranking end ======= -->
                            </div>
                        </div>

                        <div class="table-div">
                            <p-table class="expandable" #dt [value]="scoreList"  [paginator]="true" [rows]="pageLimitFirst" [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both" (onPage)="onUserScorePageChange($event)" (onLazyLoad)="getUserScore($event)"
                             [totalRecords]="totalRecords" pageLinks="3" [showPageLinks]="true" paginatorDropdownAppendTo="body" [first]="(pageNumberFirst - 1) * pageLimitFirst" [loading]="loading" [rowsPerPageOptions]="paginationOption" styleClass="">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="display: table-cell!important;">Date</th>
                                        <th style="display: table-cell!important;">Contest Name</th>                                        
                                        <th style="display: table-cell!important;"> Point</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-result>
                                    <tr>
                                        <td> <span class="mobile-lable">Date:</span> {{result.startdate | date:'dd/MM/yyyy' }}</td>
                                        <td> 
                                            <!-- <a (click)="onclickTournamentdetails(result.id)" > -->
                                                <span class="mobile-lable">Tournament Name:</span> {{result.tournamentName}} 
                                            <!-- </a>  -->
                                        </td>
                                        <td><span class="mobile-lable">Point:</span> {{result.totalPoints}} </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6">
                                            Result not found.
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div
                                        class="p-d-flex p-ai-center p-jc-between">
                                        In total there are
                                        {{totalRecords}} Results.
                                    </div>
                                </ng-template>
                            </p-table>
                        </div> 
                                                
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ======= End About Us Section ======= -->
</main>
<!-- End #main -->